// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResultGrid_root__11Exb","singleColumn":"SearchResultGrid_singleColumn__OZ9gk","responsive":"SearchResultGrid_responsive__pL2eC"};